<template>
  <v-select
    color="primary"
    :items="choices"
    :class="`${dirtyClass} fill-height option-field`"
    :model-value="select"
    append-icon=""
    item-title="display_name"
    item-value="value"
    @update:model-value="
      $emit('update'),
        $emit('set', {
          item: item,
          value: $event.value,
          parameter: parameter
        })
    "
    style="font-size: 14px"
    hide-details
    persistent-hint
    variant="plain"
    return-object
    density="compact"
    :disabled="disabled"
    :readonly="!editable"
    :menu-icon="!editable ? '' : undefined"
  />
</template>

<script>
export default {
  name: 'OptionField',
  data: () => ({
    select: { display_name: 'Select', value: '' },
    choices: []
  }),
  props: {
    parameter: { required: true },
    item: { required: true },
    disabled: { default: false, required: false },
    options: { default: {}, required: false },
    dirtyClass: { required: false },
    editable: { default: true, required: false }
  },
  watch: {
    options() {
      this.fetchOptions()
    },
    item: {
      handler() {
        this.getValueOptions()
      },
      deep: true
    }
  },
  methods: {
    fetchOptions() {
      if (this.options && this.options[this.parameter] && this.options[this.parameter].choices) {
        this.choices = this.options[this.parameter].choices
        this.getValueOptions()
      }
    },
    getValueOptions() {
      if (this.item[this.parameter] !== undefined) {
        this.select = this.choices.find((element) => this.item[this.parameter] === element.value)
      }
    }
  },
  mounted() {
    this.fetchOptions()
  }
}
</script>

<style scoped>
:deep(.v-select__selection) {
  font-size: 14px;
}
</style>
